// src/data/routesData.js

/**
 * Données extraites du fichier Excel 071125.xlsm :
 * - 58 trajets (codes de l'onglet PARAMETRE)
 * - Prix du billet remplis lorsqu'ils sont présents dans les feuilles journalières
 *   (NDJA-MOUNDOU, NDJ-ABECHE, LERE, PALA, CROISEMENT-SUD).
 * - Les autres champs (durée, distance, horaires, jours) restent à compléter
 *   car ils ne figurent pas de façon structurée dans le fichier.
 */

export const routesData = [
  {
    id: 'abeche-angoura',
    code: 'ABECHE-ANGOURA',
    departure: 'Abéché',
    arrival: 'Angoura',
    price: 0,
    duration: '',
    distance: '',
    frequency: '6 tours/jour',
    departureTime: '03h00 / 03h-04h / 04h-06h30 / 11h-13h / 13h-15h / 15h-17h',
    arrivalTime: '',
    days: 'Tous les jours',
    isPopular: false,
  },
  {
    id: 'abeche-bitkine',
    code: 'ABECHE-BITKINE',
    departure: 'Abéché',
    arrival: 'Bitkine',
    price: 15000,
    duration: '',
    distance: '',
    frequency: '',
    departureTime: '04h00',
    arrivalTime: '',
    days: 'Tous les jours',
    isPopular: false,
  },
  {
    id: 'abeche-bokoro',
    code: 'ABECHE-BOKORO',
    departure: 'Abéché',
    arrival: 'Bokoro',
    price: 25000,
    priceNote: 'Tarif axe NORD: 25 000f',
    duration: '',
    distance: '',
    frequency: '',
    departureTime: '04h00',
    arrivalTime: '',
    days: 'Tous les jours',
    isPopular: false,
  },
  {
    id: 'abeche-mangalme',
    code: 'ABECHE-MANGALME',
    departure: 'Abéché',
    arrival: 'Mangalme',
    price: 12500,
    duration: '',
    distance: '',
    frequency: '',
    departureTime: '04h00',
    arrivalTime: '',
    days: 'Tous les jours',
    isPopular: false,
  },
  {
    id: 'abeche-mongo',
    code: 'ABECHE-MONGO',
    departure: 'Abéché',
    arrival: 'Mongo',
    price: 12500,
    duration: '',
    distance: '',
    frequency: '',
    departureTime: '04h00',
    arrivalTime: '',
    days: 'Tous les jours',
    isPopular: false,
  },
  {
    id: 'abeche-ndjamena',
    code: 'ABECHE-N\'DJAMENA',
    departure: 'Abéché',
    arrival: 'N\'Djaména',
    price: 25000,
    duration: '',
    distance: '',
    frequency: '',
    departureTime: '04h00',
    arrivalTime: '',
    days: 'Tous les jours',
    isPopular: false,
  },
  {
    id: 'abeche-oumhadjar',
    code: 'ABECHE-OUMHADJAR',
    departure: 'Abéché',
    arrival: 'Oum Hadjar',
    price: 5000,
    duration: '',
    distance: '',
    frequency: '',
    departureTime: '04h00',
    arrivalTime: '',
    days: 'Tous les jours',
    isPopular: false,
  },
  {
    id: 'bongor-kelo',
    code: 'BONGOR-KELO',
    departure: 'Bongor',
    arrival: 'Kélo',
    price: 0,
    duration: '',
    distance: '',
    frequency: '',
    departureTime: '',
    arrivalTime: '',
    days: '',
    isPopular: false,
  },
  {
    id: 'bongor-moundou',
    code: 'BONGOR-MOUNDOU',
    departure: 'Bongor',
    arrival: 'Moundou',
    price: 0,
    duration: '',
    distance: '',
    frequency: '',
    departureTime: '',
    arrivalTime: '',
    days: '',
    isPopular: false,
  },
  {
    id: 'kelo-bongor',
    code: 'KELO-BONGOR',
    departure: 'Kélo',
    arrival: 'Bongor',
    price: 3000,
    duration: '',
    distance: '',
    frequency: '',
    departureTime: '',
    arrivalTime: '',
    days: '',
    isPopular: false,
  },
  {
    id: 'kelo-guel',
    code: 'KELO-GUEL',
    departure: 'Kélo',
    arrival: 'Guel',
    price: 0,
    duration: '',
    distance: '',
    frequency: '',
    departureTime: '',
    arrivalTime: '',
    days: '',
    isPopular: false,
  },
  {
    id: 'kelo-guelendeng',
    code: 'KELO-GUELENDENG',
    departure: 'Kélo',
    arrival: 'Guelendeng',
    price: 0,
    duration: '',
    distance: '',
    frequency: '',
    departureTime: '',
    arrivalTime: '',
    days: '',
    isPopular: false,
  },
  {
    id: 'kelo-lere',
    code: 'KELO-LERE',
    departure: 'Kélo',
    arrival: 'Léré',
    price: 0,
    duration: '',
    distance: '',
    frequency: '',
    departureTime: '',
    arrivalTime: '',
    days: '',
    isPopular: false,
  },
  {
    id: 'kelo-moundou',
    code: 'KELO-MOUNDOU',
    departure: 'Kélo',
    arrival: 'Moundou',
    price: 0,
    duration: '',
    distance: '',
    frequency: '',
    departureTime: '',
    arrivalTime: '',
    days: '',
    isPopular: false,
  },
  {
    id: 'kelo-ndj',
    code: 'KELO-NDJ',
    departure: 'Kélo',
    arrival: 'N\'Djaména',
    price: 10000,
    duration: '',
    distance: '',
    frequency: '',
    departureTime: '',
    arrivalTime: '',
    days: '',
    isPopular: false,
  },
  {
    id: 'kelo-pala',
    code: 'KELO-PALA',
    departure: 'Kélo',
    arrival: 'Pala',
    price: 0,
    duration: '',
    distance: '',
    frequency: '',
    departureTime: '',
    arrivalTime: '',
    days: '',
    isPopular: false,
  },
  {
    id: 'lere-bongor',
    code: 'LERE-BONGOR',
    departure: 'Léré',
    arrival: 'Bongor',
    price: 8000,
    duration: '',
    distance: '',
    frequency: '',
    departureTime: '',
    arrivalTime: '',
    days: '',
    isPopular: false,
  },
  {
    id: 'lere-guel',
    code: 'LERE-GUEL',
    departure: 'Léré',
    arrival: 'Guel',
    price: 8000,
    duration: '',
    distance: '',
    frequency: '',
    departureTime: '',
    arrivalTime: '',
    days: '',
    isPopular: false,
  },
  {
    id: 'lere-kelo',
    code: 'LERE-KELO',
    departure: 'Léré',
    arrival: 'Kélo',
    price: 5000,
    duration: '',
    distance: '',
    frequency: '',
    departureTime: '',
    arrivalTime: '',
    days: '',
    isPopular: false,
  },
  {
    id: 'lere-ndj',
    code: 'LERE-NDJ',
    departure: 'Léré',
    arrival: 'N\'Djaména',
    price: 14000,
    duration: '',
    distance: '',
    frequency: '',
    departureTime: '',
    arrivalTime: '',
    days: '',
    isPopular: false,
  },
  {
    id: 'lere-pala',
    code: 'LERE-PALA',
    departure: 'Léré',
    arrival: 'Pala',
    price: 2500,
    duration: '',
    distance: '',
    frequency: '',
    departureTime: '',
    arrivalTime: '',
    days: '',
    isPopular: false,
  },
  {
    id: 'lere-pont',
    code: 'LERE-PONT',
    departure: 'Léré',
    arrival: 'Pont',
    price: 5000,
    duration: '',
    distance: '',
    frequency: '',
    departureTime: '',
    arrivalTime: '',
    days: '',
    isPopular: false,
  },
  {
    id: 'mongo-abeche',
    code: 'MONGO-ABECHE',
    departure: 'Mongo',
    arrival: 'Abéché',
    price: 0,
    duration: '',
    distance: '',
    frequency: '',
    departureTime: '',
    arrivalTime: '',
    days: '',
    isPopular: false,
  },
  {
    id: 'mongo-bitkine',
    code: 'MONGO-BITKINE',
    departure: 'Mongo',
    arrival: 'Bitkine',
    price: 0,
    duration: '',
    distance: '',
    frequency: '',
    departureTime: '',
    arrivalTime: '',
    days: '',
    isPopular: false,
  },
  {
    id: 'mongo-bokoro',
    code: 'MONGO-BOKORO',
    departure: 'Mongo',
    arrival: 'Bokoro',
    price: 0,
    duration: '',
    distance: '',
    frequency: '',
    departureTime: '',
    arrivalTime: '',
    days: '',
    isPopular: false,
  },
  {
    id: 'mongo-mangalme',
    code: 'MONGO-MANGALME',
    departure: 'Mongo',
    arrival: 'Mangalme',
    price: 0,
    duration: '',
    distance: '',
    frequency: '',
    departureTime: '',
    arrivalTime: '',
    days: '',
    isPopular: false,
  },
  {
    id: 'mongo-ndj',
    code: 'MONGO-NDJ',
    departure: 'Mongo',
    arrival: 'N\'Djaména',
    price: 0,
    duration: '',
    distance: '',
    frequency: '',
    departureTime: '',
    arrivalTime: '',
    days: '',
    isPopular: false,
  },
  {
    id: 'mongo-oumhadjar',
    code: 'MONGO-OUMHADJAR',
    departure: 'Mongo',
    arrival: 'Oum Hadjar',
    price: 0,
    duration: '',
    distance: '',
    frequency: '',
    departureTime: '',
    arrivalTime: '',
    days: '',
    isPopular: false,
  },
  {
    id: 'mound-djoumane',
    code: 'MOUND-DJOUMANE',
    departure: 'Moundou',
    arrival: 'Djoumane',
    price: 5000,
    duration: '',
    distance: '',
    frequency: '4 départs/jour',
    departureTime: '06h00 / 09h00 / 13h00 / 19h00',
    arrivalTime: '',
    days: 'Tous les jours',
    isPopular: false,
  },
  {
    id: 'moundou-bongor',
    code: 'MOUNDOU-BONGOR',
    departure: 'Moundou',
    arrival: 'Bongor',
    price: 8000,
    duration: '',
    distance: '',
    frequency: '4 départs/jour',
    departureTime: '06h00 / 09h00 / 13h00 / 19h00',
    arrivalTime: '',
    days: 'Tous les jours',
    isPopular: false,
  },
  {
    id: 'moundou-guelendeng',
    code: 'MOUNDOU-GUELENDENG',
    departure: 'Moundou',
    arrival: 'Guelendeng',
    price: 10000,
    priceNote: 'Affiche: \'Guelinding\' (Guelendeng)',
    duration: '',
    distance: '',
    frequency: '4 départs/jour',
    departureTime: '06h00 / 09h00 / 13h00 / 19h00',
    arrivalTime: '',
    days: 'Tous les jours',
    isPopular: false,
  },
  {
    id: 'moundou-kelo',
    code: 'MOUNDOU-KELO',
    departure: 'Moundou',
    arrival: 'Kélo',
    price: 2500,
    duration: '',
    distance: '',
    frequency: '4 départs/jour',
    departureTime: '06h00 / 09h00 / 13h00 / 19h00',
    arrivalTime: '',
    days: 'Tous les jours',
    isPopular: false,
  },
  {
    id: 'moundou-ndj',
    code: 'MOUNDOU-NDJ',
    departure: 'Moundou',
    arrival: 'N\'Djaména',
    price: 12500,
    duration: '',
    distance: '',
    frequency: '4 départs/jour',
    departureTime: '06h00 / 09h00 / 13h00 / 19h00',
    arrivalTime: '',
    days: 'Tous les jours',
    isPopular: true,
  },
  {
    id: 'moundou-abeche',
    code: 'MOUNDOU-ABECHE',
    departure: 'Moundou',
    arrival: 'Abéché',
    price: 36000,
    duration: '',
    distance: '',
    frequency: '4 départs/jour',
    departureTime: '06h00 / 09h00 / 13h00 / 19h00',
    arrivalTime: '',
    days: 'Tous les jours',
    isPopular: false,
  },
  {
    id: 'moundou-oumhadjar',
    code: 'MOUNDOU-OUMHADJAR',
    departure: 'Moundou',
    arrival: 'Oum Hadjar',
    price: 36000,
    duration: '',
    distance: '',
    frequency: '4 départs/jour',
    departureTime: '06h00 / 09h00 / 13h00 / 19h00',
    arrivalTime: '',
    days: 'Tous les jours',
    isPopular: false,
  },
  {
    id: 'moundou-mangalme',
    code: 'MOUNDOU-MANGALME',
    departure: 'Moundou',
    arrival: 'Mangalme',
    price: 32000,
    duration: '',
    distance: '',
    frequency: '4 départs/jour',
    departureTime: '06h00 / 09h00 / 13h00 / 19h00',
    arrivalTime: '',
    days: 'Tous les jours',
    isPopular: false,
  },
  {
    id: 'moundou-mongo',
    code: 'MOUNDOU-MONGO',
    departure: 'Moundou',
    arrival: 'Mongo',
    price: 25000,
    duration: '',
    distance: '',
    frequency: '4 départs/jour',
    departureTime: '06h00 / 09h00 / 13h00 / 19h00',
    arrivalTime: '',
    days: 'Tous les jours',
    isPopular: false,
  },
  {
    id: 'moundou-bokoro-bitkime',
    code: 'MOUNDOU-BOKORO-BITKIME',
    departure: 'Moundou',
    arrival: 'Bokoro-Bitkime',
    price: 22500,
    priceNote: 'Affiche: \'Bokoro-Bitkime : 22 500f\'',
    duration: '',
    distance: '',
    frequency: '4 départs/jour',
    departureTime: '06h00 / 09h00 / 13h00 / 19h00',
    arrivalTime: '',
    days: 'Tous les jours',
    isPopular: false,
  },
  {
    id: 'ndj-abeche',
    code: 'NDJ-ABECHE',
    departure: 'N\'Djaména',
    arrival: 'Abéché',
    price: 25000,
    duration: '',
    distance: '',
    frequency: '',
    departureTime: '04h00',
    arrivalTime: '',
    days: 'Tous les jours',
    isPopular: true,
  },
  {
    id: 'ndj-bitkine',
    code: 'NDJ-BITKINE',
    departure: 'N\'Djaména',
    arrival: 'Bitkine',
    price: 10000,
    duration: '',
    distance: '',
    frequency: '',
    departureTime: '04h00',
    arrivalTime: '',
    days: 'Tous les jours',
    isPopular: false,
  },
  {
    id: 'ndj-bokoro',
    code: 'NDJ-BOKORO',
    departure: 'N\'Djaména',
    arrival: 'Bokoro',
    price: 9000,
    priceMax: 10000,
    priceNote: '9 000f (axe NORD) / 10 000f (note)',
    duration: '',
    distance: '',
    frequency: '',
    departureTime: '04h00',
    arrivalTime: '',
    days: 'Tous les jours',
    isPopular: false,
  },
  {
    id: 'ndj-bongor',
    code: 'NDJ-BONGOR',
    departure: 'N\'Djaména',
    arrival: 'Bongor',
    price: 8000,
    duration: '',
    distance: '',
    frequency: '',
    departureTime: '',
    arrivalTime: '',
    days: '',
    isPopular: true,
  },
  {
    id: 'ndj-djoumane',
    code: 'NDJ-DJOUMANE',
    departure: 'N\'Djaména',
    arrival: 'Djoumane',
    price: 9000,
    duration: '',
    distance: '',
    frequency: '',
    departureTime: '',
    arrivalTime: '',
    days: '',
    isPopular: false,
  },
  {
    id: 'ndj-doba',
    code: 'NDJ-DOBA',
    departure: 'N\'Djaména',
    arrival: 'Doba',
    price: 14000,
    duration: '',
    distance: '',
    frequency: '',
    departureTime: '',
    arrivalTime: '',
    days: '',
    isPopular: false,
  },
  {
    id: 'ndj-guelendeng',
    code: 'NDJ-GUELENDENG',
    departure: 'N\'Djaména',
    arrival: 'Guelendeng',
    price: 6000,
    duration: '',
    distance: '',
    frequency: '',
    departureTime: '',
    arrivalTime: '',
    days: '',
    isPopular: false,
  },
  {
    id: 'ndj-kelo',
    code: 'NDJ-KELO',
    departure: 'N\'Djaména',
    arrival: 'Kélo',
    price: 10000,
    duration: '',
    distance: '',
    frequency: '',
    departureTime: '',
    arrivalTime: '',
    days: '',
    isPopular: false,
  },
  {
    id: 'ndj-koumra',
    code: 'NDJ-KOUMRA',
    departure: 'N\'Djaména',
    arrival: 'Koumra',
    price: 15000,
    duration: '',
    distance: '',
    frequency: '',
    departureTime: '',
    arrivalTime: '',
    days: '',
    isPopular: false,
  },
  {
    id: 'ndj-lere',
    code: 'NDJ-LERE',
    departure: 'N\'Djaména',
    arrival: 'Léré',
    price: 14000,
    duration: '',
    distance: '',
    frequency: '',
    departureTime: '',
    arrivalTime: '',
    days: '',
    isPopular: false,
  },
  {
    id: 'ndj-limia',
    code: 'NDJ-LIMIA',
    departure: 'N\'Djaména',
    arrival: 'Limia',
    price: 0,
    duration: '',
    distance: '',
    frequency: '',
    departureTime: '',
    arrivalTime: '',
    days: '',
    isPopular: false,
  },
  {
    id: 'ndj-mangalme',
    code: 'NDJ-MANGALME',
    departure: 'N\'Djaména',
    arrival: 'Mangalme',
    price: 20000,
    duration: '',
    distance: '',
    frequency: '',
    departureTime: '04h00',
    arrivalTime: '',
    days: 'Tous les jours',
    isPopular: false,
  },
  {
    id: 'ndj-mongo',
    code: 'NDJ-MONGO',
    departure: 'N\'Djaména',
    arrival: 'Mongo',
    price: 12500,
    duration: '',
    distance: '',
    frequency: '',
    departureTime: '04h00',
    arrivalTime: '',
    days: 'Tous les jours',
    isPopular: false,
  },
  {
    id: 'ndj-moundou',
    code: 'NDJ-MOUNDOU',
    departure: 'N\'Djaména',
    arrival: 'Moundou',
    price: 12500,
    duration: '',
    distance: '',
    frequency: '',
    departureTime: '',
    arrivalTime: '',
    days: '',
    isPopular: true,
  },
  {
    id: 'ndj-ngoure',
    code: 'NDJ-NGOURE',
    departure: 'N\'Djaména',
    arrival: 'Ngouré',
    price: 0,
    duration: '',
    distance: '',
    frequency: '',
    departureTime: '',
    arrivalTime: '',
    days: '',
    isPopular: false,
  },
  {
    id: 'ndj-oumhadjar',
    code: 'NDJ-OUMHADJAR',
    departure: 'N\'Djaména',
    arrival: 'Oum Hadjar',
    price: 25000,
    duration: '',
    distance: '',
    frequency: '',
    departureTime: '04h00',
    arrivalTime: '',
    days: 'Tous les jours',
    isPopular: false,
  },
  {
    id: 'ndj-pala',
    code: 'NDJ-PALA',
    departure: 'N\'Djaména',
    arrival: 'Pala',
    price: 12500,
    duration: '',
    distance: '',
    frequency: '',
    departureTime: '',
    arrivalTime: '',
    days: '',
    isPopular: true,
  },
  {
    id: 'ndj-peni',
    code: 'NDJ-PENI',
    departure: 'N\'Djaména',
    arrival: 'Péni',
    price: 0,
    duration: '',
    distance: '',
    frequency: '',
    departureTime: '',
    arrivalTime: '',
    days: '',
    isPopular: false,
  },
  {
    id: 'ndj-pont',
    code: 'NDJ-PONT',
    departure: 'N\'Djaména',
    arrival: 'Pont',
    price: 15000,
    duration: '',
    distance: '',
    frequency: '',
    departureTime: '',
    arrivalTime: '',
    days: '',
    isPopular: false,
  },
  {
    id: 'ndj-sahr',
    code: 'NDJ-SAHR',
    departure: 'N\'Djaména',
    arrival: 'Sarh',
    price: 17500,
    duration: '',
    distance: '',
    frequency: '',
    departureTime: '',
    arrivalTime: '',
    days: '',
    isPopular: true,
  },
  {
    id: 'oumha-eref',
    code: 'OUMHA-EREF',
    departure: 'Oumha',
    arrival: 'Eref',
    price: 0,
    duration: '',
    distance: '',
    frequency: '',
    departureTime: '',
    arrivalTime: '',
    days: '',
    isPopular: false,
  },
  {
    id: 'oumhadjar-mongo',
    code: 'OUMHADJAR-MONGO',
    departure: 'Oum Hadjar',
    arrival: 'Mongo',
    price: 0,
    duration: '',
    distance: '',
    frequency: '',
    departureTime: '',
    arrivalTime: '',
    days: '',
    isPopular: false,
  },
  {
    id: 'pala-bongor',
    code: 'PALA-BONGOR',
    departure: 'Pala',
    arrival: 'Bongor',
    price: 0,
    duration: '',
    distance: '',
    frequency: '',
    departureTime: '',
    arrivalTime: '',
    days: '',
    isPopular: false,
  },
  {
    id: 'pala-kelo',
    code: 'PALA-KELO',
    departure: 'Pala',
    arrival: 'Kélo',
    price: 3000,
    duration: '',
    distance: '',
    frequency: '',
    departureTime: '',
    arrivalTime: '',
    days: '',
    isPopular: false,
  },
  {
    id: 'pala-ndj',
    code: 'PALA-NDJ',
    departure: 'Pala',
    arrival: 'N\'Djaména',
    price: 12500,
    duration: '',
    distance: '',
    frequency: '',
    departureTime: '',
    arrivalTime: '',
    days: '',
    isPopular: false,
  },
];

export const getPopularRoutes = (limit = 3) => {
  const popular = routesData.filter((r) => r.isPopular);
  if (popular.length > 0) {
    return popular.slice(0, limit);
  }
  return routesData.slice(0, limit);
};

export const toScheduleRows = () =>
  routesData.map((r) => ({
    route: `${r.departure} → ${r.arrival}`,
    departure: r.departureTime || 'À confirmer',
    arrival: r.arrivalTime || 'À confirmer',
    price: r.price ?? 0,
    days: r.days || 'À confirmer',
  }));
